import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  UPDATE_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNIN_USER_BY_TOKEN_SUCCESS,
  LOAD_AUTHEN
} from "constants/ActionTypes";

const INIT_STATE = {
  loadAuthen:true,
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: null,
  profile:{}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.token,
        profile: action.profile,
        loadAuthen:false
      }
    }
    case UPDATE_USER: {
      return {
        ...state,
        profile: action.profile
      }
    }
    case SIGNIN_USER_BY_TOKEN_SUCCESS: {

      return {
        ...state,
        loader: false,
        loadAuthen:false,
        authUser: action.token,
        profile: action.profile
      }
    }
    case LOAD_AUTHEN: {
      return {
        ...state,
        loadAuthen: action.payload
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        loadAuthen:false,
        authUser: null,
        initURL: '/',
        loader: false
      }
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    default:
      return state;
  }
}
